export default "__VITE_ASSET__Ch09A6Po__"